<template>
  <section class="py-5 sm:py-7 md:py-8 lg:pb-5 lg:pt-9 lg:mt-n9 relative overflow-hidden news-card-slider">
    <div class="news-slider-container">
      <div class="container static">
        <header>
          <h2 class="mb-2 lg:mb-5 text-center">
            {{ t('news') }}
          </h2>
        </header>
      </div>
      <HomeNewsGrid
        v-if="news.length > 0"
        :news="news"
      />
      <BaseLoading
        v-else
        :style="{ minHeight: '580px' }"
      />
      <div
        v-if="!BrowserService.isWideScreen()"
        class="container static"
      >
        <!-- Heading -->
        <HomeNewsCarousel
          v-if="news.length > 0"
          :news="news"
        />
        <BaseLoading
          v-else
          :style="{ minHeight: '430px' }"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import RetailApiV2 from '@/api/retailApi/RetailApiV2'
import BaseLoading from '@/components/general/BaseLoading.vue'
import HomeNewsCarousel from '@/components/home/HomeNewsCarousel.vue'
import HomeNewsGrid from '@/components/home/HomeNewsGrid.vue'
import BrowserService from '@/services/browserService'

const { t } = useI18n()

const news = ref([])
const loadNews = async () => {
  const { data } = await RetailApiV2.get('news?limit=7')
  news.value = data.news
}
loadNews()
</script>

<i18n>
  {
    "cs": {
    "news": "Novinky"
},
    "sk": {
    "news": "Novinky"
},
    "pl": {
    "news": "Nowości"
},
    "hu": {
    "news": "Újdonságok"
},
    "de": {
    "news": "Neuheiten"
},
    "at": {
    "news": "Neuheiten"
},
    "ro": {
    "news": "Noutăți"
}
  }
</i18n>
